export function isEnumMember<E extends Record<string, string>>(
  enumObject: E,
  value: unknown,
): value is E[keyof E] {
  return typeof value === 'string' && (Object.values(enumObject) as string[]).includes(value);
}
